/**
 * The toasts of the staff screens over the admins. See `feedbackCatalog` for
 * what each field means.
 */
export const ADMINS_FEEDBACK_RULES = {
  // The switch shows what came back; the toast says it was saved, or why not.
  'admins/updateStaffAdminPlan': {
    success: 'Plan actualizado',
    testId: 'admin-detail-notice',
  },
};
